<template>
  <v-dialog
    id="supportContract-modal-form"
    ref="supportContractModalForm"
    v-model="$store.state.supportContractModalFormOpen"
    width="600"
    :disabled="!isPermittedAll(['SupportContractsGeyByID'])"
    persistent
    no-click-animation>
    <form
      @submit.prevent="saveSupportContract">
      <v-container
        class="px-5 pb-2 pt-0">
        <!-- Title -->
        <v-row>
          <v-col
            class="d-flex pr-0">
            <h2>
              <span
                v-if="$store.getters.isActiveSupportContractDirty">
                *
              </span>
              <span
                v-if="activeSupportContract.SupportContractID">
                Edit
              </span>
              <span
                v-else>
                Add
              </span>
              Support Contract
              <span
                v-if="activeSupportContract.SupportContractID">
                #{{activeSupportContract.SupportContractID}}
              </span>
            </h2>
            <v-btn
              class="square ml-auto"
              type="button"
              text
              @click="closeSupportContractModal()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <!-- / Title -->

        <!-- Start / End -->
        <v-row>
          <v-col>
            <DatePicker
              input-id="support-contract-start-date"
              v-model="activeSupportContract.SupportContractStartUtc"
              label="Start Date:"
              :line-bottom="true"
              :readonly="$store.getters.isLoadingActive"
            />
          </v-col>
          <v-col>
            <DatePicker
              input-id="support-contract-end-date"
              v-model="activeSupportContract.SupportContractEndUtc"
              label="End Date:"
              :line-bottom="true"
              :readonly="$store.getters.isLoadingActive"
            />
          </v-col>
        </v-row>
        <!-- / Start / End -->

        <!-- Notes -->
        <v-row>
          <v-col>
            <label
              for="support-contract-notes">
              Notes:
            </label>
            <v-textarea
              id="support-contract-notes"
              name="supportContractNotes"
              class="pt-0 mt-0"
              rows="2"
              v-model="activeSupportContract.SupportContractNotes"
              :readonly="$store.getters.isLoadingActive"
              hide-details
              no-resize>
            </v-textarea>
          </v-col>
        </v-row>
        <!-- / Notes -->

        <!-- Buttons -->
        <v-row>
          <v-col
             class="d-flex justify-end">
              <LastModifiedBy
              :entity="activeSupportContract"
            />
          </v-col>
          <v-col class="d-flex align-center">

            <v-btn
              v-if="isPermittedToSave"
              class="ml-auto"
              type="submit"
              color="primary"
              :disabled="$store.getters.isLoadingActive
                || !$store.getters.isActiveSupportContractDirty">
              Save
            </v-btn>

            <v-btn
              v-if="activeSupportContract.SupportContractID
                && isPermittedAll([
                  'SupportContractsDelete',
                ])
                && !activeSupportContract.SupportContractIsDeleted"
              type="button"
              color="error"
              class="order-first mr-5"
              outlined
              @click="hideSupportContract"
              :disabled="$store.getters.isLoadingActive">
              Hide Support Contract
            </v-btn>

            <v-btn
              v-if="activeSupportContract.SupportContractID
                && isPermittedAll([
                  'SupportContractsRestore',
                ])
                && activeSupportContract.SupportContractIsDeleted"
              type="button"
              color="error"
              class="order-first mr-5"
              outlined
              @click="restoreSupportContract"
              :disabled="$store.getters.isLoadingActive">
              Unhide Support Contract
            </v-btn>
          </v-col>
        </v-row>
        <!-- / Buttons -->
      </v-container>
    </form>
  </v-dialog>
</template>

<script>
import _ from 'lodash';
import DatePicker from './DatePicker.vue';
import LastModifiedBy from './LastModifiedBy.vue';

export default {
  name: 'SupportContractModalForm',
  components: {
    DatePicker,
    LastModifiedBy,
  },
  computed: {
    isPermittedToSave() {
      return (!this.activeSupportContract.SupportContractID
          && this.isPermittedAll(['SupportContractsCreate']))
        || (this.activeSupportContract.SupportContractID
          && this.isPermittedAll(['SupportContractsUpdate']));
    },
    activeSupportContract() {
      return this.$store.state.activeSupportContract;
    },
  },
  methods: {
    closeSupportContractModal(skipDirtyCheck) {
      const confirm = () => {
        this.$store.commit('setSupportContractModalFormOpen', false);
        setTimeout(() => {
          this.$store.commit('setActiveSupportContract');
        }, 200);
      };

      if (this.$store.getters.isActiveSupportContractDirty && !skipDirtyCheck) {
        this.showConfirm(
          'Are you sure you want to leave this support contract without saving?',
          'You have unsaved changes',
        ).then(confirm, _.noop);
      } else {
        confirm();
      }
    },
    saveSupportContract() {
      let promise = Promise.resolve();

      if (this.activeSupportContract.SupportContractID) {
        promise = this.$store.dispatch('updateSupportContract');
      } else {
        promise = this.$store.dispatch('createSupportContract');
      }

      promise
        .then(() => this.closeSupportContractModal(true));
    },
    hideSupportContract() {
      const confirm = () => {
        this.$store.dispatch('deleteSupportContract')
          .then(() => {
            this.closeSupportContractModal(true);
          });
      };

      this.showConfirm(
        'Are you sure you want to hide this support contract?',
        'Hide SupportContract',
      ).then(confirm, _.noop);
    },
    restoreSupportContract() {
      const confirm = () => {
        this.$store.dispatch('restoreSupportContract')
          .then(() => {
            this.closeSupportContractModal(true);
          });
      };

      this.showConfirm(
        'Are you sure you want to unhide this support contract?',
        'Hide SupportContract',
      ).then(confirm, _.noop);
    },
  },
};
</script>

<style lang="scss"></style>
